<template>
  <div class="mb-8">
    <div class="flex items-center">
      <p class="text-dark-blue">
        {{ subject }}
      </p>
      <slot />
    </div>
    <p class="mb-4 text-xxs font-bold uppercase text-gray-over-dark">
      {{ question?.description }}
    </p>
    <input
      v-model="answer"
      class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
      type="text"
      placeholder=""
      @input="handleInput"
    />
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    setOnboardingPacket: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
  },
  emits: ['child-check', 'group-check'],
  data() {
    return {
      answer: '',
    };
  },
  computed: {
    stepName() {
      return this.$store.state.formRoutes?.activeStepIdentifier;
    },
  },
  // created() {
  //   let recentAnswer = this.question?.most_recent_previous_answer;
  //   if (recentAnswer) {
  //     this.answer = recentAnswer?.string_value;
  //     this.handleAutoInput();
  //   }
  // },
  watch: {
    stepName: {
      handler(newVal) {
        if (newVal == 'Questions') {
          let recentAnswer = this.question?.most_recent_previous_answer;
          if (recentAnswer) {
            this.answer = recentAnswer?.string_value;
            this.handleAutoInput();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleInput(e) {
      let body = null;
      if (this.answer?.length > 0) {
        body = {
          company_question_id: this.question_id,
          string_value: e?.target?.value,
        };
      }
      this.setOnboardingPacket(body);
      if (this.required) {
        this.answer
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(e?.target?.value);
    },
    handleAutoInput() {
      let body = null;
      if (this.answer?.length > 0) {
        body = {
          company_question_id: this.question_id,
          string_value: this.answer,
        };
      }
      this.setOnboardingPacket(body);
      if (this.required) {
        this.answer
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.answer);
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (
            child?.evaluation_js?.length > 0 &&
            child?.company_question_id > 0
          ) {
            this.$emit(
              'child-check',
              child?.company_question_id,
              value,
              child?.evaluation_js,
              child?.is_shown_by_default,
              child?.is_required
            );
          }
        });
      }
    },
  },
};
</script>
